export { default as LineLoader } from './Line/component'
export { default as SpinnerLoader } from './Spinner/component'
